// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.retry-XvVMKM{cursor:pointer;background:#fff;border:1px solid #e6e6e6;border-radius:10px;justify-content:center;align-items:center;padding:6px 16px;display:flex}.retry-XvVMKM:hover{background:#e6e6e6;border-color:#d0d0d0}.retry-XvVMKM:active{background:#dcdcdd;border-color:#c7c7c8}.icon-njEaqQ{color:#0064fa;margin-right:6px;font-size:16px}.text-X1Ae9l{color:#1d1c23;font-size:14px;font-weight:600;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"retry": `retry-XvVMKM`,
	"icon": `icon-njEaqQ`,
	"text": `text-X1Ae9l`
};
export default ___CSS_LOADER_EXPORT___;
